import { Box, RadioGroup, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    gap: '16px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '14px',
  },
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  width: '100%',
  marginBottom: '20px',

  '& .MuiTextField-root': {
    // Assicura che ogni controllo occupi tutta la larghezza disponibile
    '&.MuiFormControl-root': {
      width: '100%',
    },

    '& .MuiOutlinedInput-root': {
      fontSize: '1rem',
      width: '100%',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.95rem',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.85rem',
      },
    },

    '& .MuiInputLabel-root': {
      fontSize: '1rem',
      // Evita troncamenti/ellipsis del testo della label
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
      maxWidth: '100%',

      [theme.breakpoints.down('md')]: {
        fontSize: '0.95rem',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.85rem',
      },
    },

    '& .MuiFormHelperText-root': {
      fontSize: '0.875rem',

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.75rem',
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    gap: '14px',
    marginBottom: '18px',
  },

  [theme.breakpoints.down('md')]: {
    gap: '12px',
    marginBottom: '16px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    marginBottom: '14px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '8px',
    marginBottom: '12px',
  },
}));

export const RadioButtonsWrapper = styled(RadioGroup)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px 32px', // Ridotto il gap per un look più compatto
  margin: '0 0 24px 0', // Ridotto il margin bottom
  maxWidth: '400px', // Ridotto il maxWidth

  '& .MuiFormControlLabel-root': {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.9rem', // Font più piccolo
      fontWeight: 400, // Font weight normale (non grassetto)
      color: '#374151', // Colore più soft
      lineHeight: 1.4, // Line height per migliore leggibilità

      [theme.breakpoints.down('md')]: {
        fontSize: '0.85rem',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: '0.75rem',
      },
    },

    '& .MuiRadio-root': {
      padding: '6px', // Radio button più piccolo
      color: '#6b7280', // Colore più soft per i radio button

      '&.Mui-checked': {
        color: '#1EED9F', // Colore verde Kipify originale quando selezionato
      },

      [theme.breakpoints.down('sm')]: {
        padding: '4px',
      },

      [theme.breakpoints.down('xs')]: {
        padding: '3px',
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    gap: '10px 28px',
    margin: '0 0 20px 0',
    maxWidth: '380px',
  },

  [theme.breakpoints.down('md')]: {
    gap: '8px 24px',
    margin: '0 0 18px 0',
    maxWidth: '360px',
  },

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: '8px',
    width: '100%',
    margin: '0 0 16px 0',
    maxWidth: '100%',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '6px',
    margin: '0 0 14px 0',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  margin: '0 0 8px 0', // Ridotto il margin bottom
  alignSelf: 'flex-start',
  fontSize: '1rem', // Font più piccolo
  fontWeight: 500, // Font weight più leggero
  color: '#1f2937', // Colore più soft
  letterSpacing: '0.025em', // Spaziatura lettere per eleganza

  [theme.breakpoints.down('md')]: {
    fontSize: '0.95rem',
    margin: '0 0 7px 0',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    margin: '0 0 6px 0',
    marginLeft: '0',
  },

  [theme.breakpoints.down('xs')]: {
    fontSize: '0.85rem',
    margin: '0 0 5px 0',
  },
}));

export const InnerWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px 40px', // Aumentato il gap per dare più spazio ai campi

  '& .MuiTextField-root': {
    flex: 1, // Ogni campo occupa lo spazio disponibile
    minWidth: 0, // Allows fields to shrink if necessary
  },

  [theme.breakpoints.down('lg')]: {
    gap: '14px 36px',
  },

  [theme.breakpoints.down('md')]: {
    gap: '12px 32px',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '12px',
  },

  [theme.breakpoints.down('xs')]: {
    gap: '10px',
  },
}));
